import React from 'react';
import PropTypes from 'prop-types';
import BarChartVertical from 'components/common/charts/BarChartVertical';

function CountryDescription(props) {
  const { description, titleName, data, keyMessages } = props;
  return data && data.length ? (
    <article className="c-country-description l-content">
      <div className="tablet-compare-chart bar-chart-wrapper" >
        <h2 className="subtitle">{titleName}: Composite Scores Comparison</h2>
        <BarChartVertical graphHeight={260} data={data} id={'chart10'} margin={{ left: 40 }} />
      </div>
      <div className="print-8 medium-offset-1">
        <div className="country-description-text" dangerouslySetInnerHTML={{ __html: `${description || ''} ${keyMessages || ''}` }}></div>
      </div>
    </article>
  ) : (
    <article className="c-country-description l-content">
      <div className="row">
        <div className="column small-12 medium-10 medium-offset-1 large-10 print-8">
          <div className="country-description-text" dangerouslySetInnerHTML={{ __html: `${description || ''} ${keyMessages || ''}` }}></div>
        </div>
      </div>
    </article>
  );
}

CountryDescription.propTypes = {
  description: PropTypes.any,
  data: PropTypes.array,
  name: PropTypes.string,
  keyMessages: PropTypes.string,
  sector: PropTypes.string,
  titleName: PropTypes.string
};

export default CountryDescription;



// WEBPACK FOOTER //
// ./app/components/country-profiles/show/CountryDescription.jsx